import MeeyImage from "@/components/MeeyImage";
import Modal from "@/components/Modal";
import VideoPlayer from "@/components/VideoPlayer";
import { APP_MEEYPROJECT_URL } from "@/constants/environment";
import { ProjectContext } from "@/context/project.context";
import { formatNumber } from "@/utils/number";
import { VideoItem } from "Models";
import Link from "next/link";
import { useContext, useMemo, useState } from "react";

const ProjectVideoBox = () => {
  const [currentVideo, setCurrrentVideo] = useState<VideoItem>(null);
  const { projectVideos, project } = useContext(ProjectContext);

  const bigVideoCard = useMemo<VideoItem>(() => {
    return projectVideos.length >= 3 || projectVideos.length == 1
      ? projectVideos[0]
      : null;
  }, [projectVideos]);

  const smallVideoCard = useMemo<VideoItem[]>(() => {
    return projectVideos.length >= 3
      ? projectVideos.slice(1, 3)
      : projectVideos.length == 2
      ? projectVideos.slice(0, 2)
      : [];
  }, [projectVideos]);

  return (
    <>
      <div className="bg-white rounded-lg p-3 shadow-light-1 w-full">
        <div className="text-grey-500 text-fs-14 font-medium">
          THÔNG TIN DỰ ÁN
        </div>
        <hr className="my-2" />
        {bigVideoCard ? (
          <div
            className="relative cursor-pointer mb-3"
            onClick={() => setCurrrentVideo(bigVideoCard)}>
            <MeeyImage src={bigVideoCard?.avatar.uri} className="rounded-md" />
            <div className="absolute  w-9 h-9 bg-[rgba(0,0,0,0.4)] rounded-full flex items-center justify-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <i className="mrv mrv-play_arrow text-white text-fs-28"></i>
            </div>
            <div className="absolute  bottom-2 left-3 text-white">
              <div className="font-semibold line-clamp-1">
                {bigVideoCard?.title}
              </div>
              {bigVideoCard.totalView ? (
                <div className="text-fs-12 flex items-center">
                  <i className="mrv mrv-visibility mr-1 text-base"></i>{" "}
                  {formatNumber(bigVideoCard.totalView) + " lượt xem"}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : null}
        {smallVideoCard?.length ? (
          <div className="flex gap-3 w-full mb-3">
            {smallVideoCard.map((card) => (
              <div
                className="relative w-[140px] cursor-pointer"
                key={card._id}
                onClick={() => setCurrrentVideo(card)}>
                <MeeyImage
                  src={card?.avatar.uri}
                  resizeOptions={{
                    width: 140,
                    height: 246,
                  }}
                  className="rounded-md object-cover w-full h-full"
                />
                <div className="absolute  w-9 h-9 bg-[rgba(0,0,0,0.4)] rounded-full flex items-center justify-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                  <i className="mrv mrv-play_arrow text-white text-fs-28"></i>
                </div>
                <div className="absolute  bottom-2 left-3 right-3 text-white">
                  <div className="font-semibold line-clamp-2">{card.title}</div>
                  {card.totalView ? (
                    <div className="text-fs-12 flex items-center">
                      <i className="mrv mrv-visibility mr-1 text-base"></i>{" "}
                      {formatNumber(card.totalView) + " lượt xem"}
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        ) : null}

        <Link
          className="font-medium"
          target="_blank"
          href={
            APP_MEEYPROJECT_URL +
            "/project/" +
            project.slug +
            "-" +
            project.shortId
          }>
          Xem thêm video đánh giá
        </Link>
      </div>

      <Modal
        open={!!currentVideo}
        onClose={() => setCurrrentVideo(null)}
        footerClassName="border-none !p-0"
        contentClassName="w-[80vw] "
        header={<div className="line-clamp-1">{currentVideo?.title}</div>}
        bodyClassName="h-[80vh] w-full">
        <VideoPlayer
          options={{
            autoplay: "muted",
            muted: true,
            controls: true,
            responsive: true,
            preload: "metadata",
            fluid: true,
            sources: [
              {
                src: currentVideo?.url,
              },
            ],
          }}
        />
      </Modal>
    </>
  );
};

export default ProjectVideoBox;
